import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';

// Component, Route, and Lib
import { routeDidUpdate } from './actions/actions-router';

import largeScreenRoutes from './routes/LargeScreenRoutes';
import rootReducer from './reducers/index';
import HelpApp from './components/HelpApp';
import getHistory from '../lib/HistoryHelper';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line  global-require
  const createLogger = require('redux-logger');
  middlewares.push(createLogger());
}

const store = createStore(rootReducer, applyMiddleware(...middlewares));

// Todo: below `basename` should be updated to `US`.
const history = getHistory();

window.histTest = history;

const currentLocation = history.location;

store.dispatch(routeDidUpdate(currentLocation));

// TODO: wire to acrtions-router after backend code

history.listen((location) => {
  store.dispatch(routeDidUpdate(location));
});

const routeConfig = largeScreenRoutes; // Using CSS to control left side display logic

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <HelpApp sideBar={routeConfig.sideBar} mainContainer={routeConfig.mainContainer} />
    </Router>
  </Provider>,
  document.querySelector('.smarthelp-react-app'),
);
